import apiClient from '../utils/apiClient';

const Service = '/Service';

// Post history report
export const postHistoryReport = async ({
  startDate,
  endDate,
  pageNumber = 1,
  pageSize = 100,
}) => {
  try {
    const response = await apiClient.post(`${Service}/History`, {
      startDate,
      endDate,
      pageNumber,
      pageSize,
    });
    return response.data;
  } catch (error) {
    console.error('Error posting history report:', error);
    throw error;
  }
};

// Get proof file
export const getProofFile = async proof => {
  try {
    const encodedProof = encodeURIComponent(proof);
    const response = await apiClient.get(`${Service}/Summary/Proof`, {
      params: { proof: encodedProof },
      responseType: 'blob', // Dosyayı binary formatta almak için
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching proof file:', error);
    throw error;
  }
};

// Download report
export const downloadReport = async (fileType, reportData) => {
  const { startDate, endDate } = reportData;

  try {
    const response = await apiClient.post(
      `${Service}/GetExcelReport`,
      { startDate, endDate },
      {
        params: { type: fileType }, // Query parametreyi buraya taşıdık
        responseType: 'blob', // Dosyayı binary formatta almak için
      }
    );

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `report.${fileType}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error downloading report:', error);
    throw error;
  }
};

// export const getProofFile = async proof => {
//   const response = await axios.get(`${API_BASE_URL}/Summary/Proof`, {
//     params: { proof: encodeURIComponent(proof) }, // Parametreyi kodlayarak gönder
//     responseType: 'blob', // Dosyayı binary formatta almak için
//   });
//   return response.data;
// };
